import React from 'react';

const ShippingPolicy: React.FC = () => {
  return (
    <div className="pt-16 bg-white min-h-screen">
      {/* Page Title */}
      <div className="bg-white text-gray-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#2b603e] to-[#1a3d25]">Shipping Policy</h1>
          <p className="text-xl max-w-3xl mx-auto text-gray-600">
            Understanding our shipping process and delivery expectations.
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="container mx-auto px-4">
        <hr className="border-t border-gray-200 my-0" />
      </div>

      {/* Shipping Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Order Processing</h2>
              <p className="text-gray-600">
                Orders are processed within 1–3 business days after payment confirmation.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Shipping Times</h2>
              <p className="text-gray-600">
                Shipping times depend on the chosen shipping method and destination. Estimated delivery for standard shipping is 2–5 business days. These are estimates and not guaranteed.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Shipping Commitment</h2>
              <p className="text-gray-600">
                Asclepius strives to ship orders promptly but is not liable for delays, loss, or damage that may occur during transit.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Customer Responsibilities</h2>
              <p className="text-gray-600">
                Shipping costs, import duties, and taxes (if applicable) are the customer’s responsibility.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Parcel Liability</h2>
              <p className="text-gray-600">
                Asclepius is not responsible for lost or damaged parcels once they have left our warehouse. We will assist customers in resolving issues with carriers when possible.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Tracking Information</h2>
              <p className="text-gray-600">
                Customers will receive tracking information when the order ships, if available.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Future Delivery Options</h2>
              <p className="text-gray-600">
                Same-day or next-day delivery is not currently available but may be introduced in the future.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Information</h2>
              <p className="text-gray-600">
                For shipping-related inquiries, please contact:
                <br />
                <strong>Email:</strong> info@asclepius-shilajit.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShippingPolicy;
